import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords, image, type = 'website' }) => {
  const { pathname } = useLocation();
  const siteUrl = 'https://sdm-menuiserie.com';
  
  useEffect(() => {
    // Mettre à jour le titre de la page
    document.title = title || 'Sénégalaise Déco Menuiserie - Meubles sur mesure à Mbour, Sénégal';
    
    // Mettre à jour les balises meta existantes ou les créer si elles n'existent pas
    const updateMetaTag = (name, content) => {
      let element = document.querySelector(`meta[name="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content || '');
    };
    
    // Mettre à jour les balises Open Graph
    const updateOGTag = (property, content) => {
      let element = document.querySelector(`meta[property="${property}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', property);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content || '');
    };
    
    // Balises meta standard
    updateMetaTag('description', description || 'Sénégalaise Déco Menuiserie (SDM) - Atelier de menuiserie et ébénisterie à Mbour, Sénégal. Fabrication artisanale de meubles sur mesure en bois massif : cuisines, dressings, portes, fenêtres. Devis gratuit ☎ +221 77 633 31 98');
    updateMetaTag('keywords', keywords || 'menuiserie Mbour, meubles sur mesure Sénégal, menuisier Mbour, ébénisterie artisanale, meubles bois massif, artisanat sénégalais, aménagement intérieur Dakar, fabrication meubles, décoration meuble, menuiserie Joal, cuisine sur mesure, dressing sur mesure, porte en bois');
    
    // Balises Open Graph
    updateOGTag('og:title', title || 'Sénégalaise Déco Menuiserie | Meubles sur mesure à Mbour, Sénégal');
    updateOGTag('og:description', description || 'Artisanat d\'excellence à Mbour. Fabrication de meubles sur mesure en bois massif : cuisines, dressings, portes, fenêtres. Devis gratuit ☎ +221 77 633 31 98');
    updateOGTag('og:type', type);
    updateOGTag('og:url', `${siteUrl}${pathname}`);
    updateOGTag('og:image', image || `${siteUrl}/og-image.jpg`);
    updateOGTag('og:image:width', '1200');
    updateOGTag('og:image:height', '630');
    updateOGTag('og:image:alt', title || 'Sénégalaise Déco Menuiserie - Atelier de menuiserie artisanale à Mbour');
    updateOGTag('og:locale', 'fr_FR');
    updateOGTag('og:site_name', 'Sénégalaise Déco Menuiserie');
    
    // Balises Twitter Card
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title || 'Sénégalaise Déco Menuiserie | Meubles sur mesure à Mbour');
    updateMetaTag('twitter:description', description || 'Artisanat d\'excellence à Mbour. Fabrication de meubles sur mesure en bois massif. Devis gratuit ☎ +221 77 633 31 98');
    updateMetaTag('twitter:image', image || `${siteUrl}/og-image.jpg`);
    updateMetaTag('twitter:image:alt', title || 'Sénégalaise Déco Menuiserie - Atelier artisanal');
    
    // Balise canonique
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}${pathname}`);
    
    // Nettoyage lors du démontage du composant
    return () => {
      // Réinitialiser les balises meta par défaut
      document.title = 'Sénégalaise Déco Menuiserie | Meubles sur mesure à Mbour, Sénégal';
      updateMetaTag('description', 'Sénégalaise Déco Menuiserie (SDM) - Atelier de menuiserie et ébénisterie à Mbour, Sénégal. Fabrication artisanale de meubles sur mesure en bois massif. Devis gratuit ☎ +221 77 633 31 98');
    };
  }, [title, description, keywords, image, type, pathname]);
  
  return (
    <Helmet>
      <title>{title || 'Sénégalaise Déco Menuiserie | Meubles sur mesure à Mbour, Sénégal'}</title>
      <meta name="description" content={description || 'Sénégalaise Déco Menuiserie (SDM) - Atelier de menuiserie et ébénisterie à Mbour, Sénégal. Fabrication artisanale de meubles sur mesure en bois massif : cuisines, dressings, portes, fenêtres. Devis gratuit ☎ +221 77 633 31 98'} />
      <meta name="keywords" content={keywords || 'menuiserie Mbour, meubles sur mesure Sénégal, menuisier Mbour, ébénisterie artisanale, meubles bois massif, artisanat sénégalais, aménagement intérieur Dakar, fabrication meubles, décoration meuble, cuisine sur mesure, dressing sur mesure'} />
      
      {/* Balises Open Graph */}
      <meta property="og:title" content={title || 'Sénégalaise Déco Menuiserie | Meubles sur mesure à Mbour, Sénégal'} />
      <meta property="og:description" content={description || 'Artisanat d\'excellence à Mbour. Fabrication de meubles sur mesure en bois massif : cuisines, dressings, portes, fenêtres. Devis gratuit ☎ +221 77 633 31 98'} />
      <meta property="og:type" content={type || 'website'} />
      <meta property="og:url" content={`https://sdm-menuiserie.com${pathname}`} />
      <meta property="og:image" content={image || 'https://sdm-menuiserie.com/og-image.jpg'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title || 'Sénégalaise Déco Menuiserie'} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="Sénégalaise Déco Menuiserie" />
      
      {/* Balises Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || 'Sénégalaise Déco Menuiserie | Meubles sur mesure à Mbour'} />
      <meta name="twitter:description" content={description || 'Artisanat d\'excellence à Mbour. Fabrication de meubles sur mesure en bois massif. Devis gratuit ☎ +221 77 633 31 98'} />
      <meta name="twitter:image" content={image || 'https://sdm-menuiserie.com/og-image.jpg'} />
      <meta name="twitter:image:alt" content={title || 'Sénégalaise Déco Menuiserie'} />
      
      {/* Balise canonique */}
      <link rel="canonical" href={`https://sdm-menuiserie.com${pathname}`} />
    </Helmet>
  );
};

export default SEO;
